import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
// Importando ícones mais adequados
import { Bell, X, CheckCircle, Info, Inbox } from "lucide-react";
import "../css/notificacoes.css"; // Importe o CSS

function Notificacoes() {
  const [notificacoes, setNotificacoes] = useState([]);
  const [open, setOpen] = useState(false);

  // Busca inicial
  useEffect(() => {
    fetchNotificacoes();
  }, []);

  const fetchNotificacoes = () => {
    const token = localStorage.getItem("Token");
    if (!token) return;

    axios
      .get("/api/notificacoes", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setNotificacoes(res.data.Result || []))
      .catch(() => setNotificacoes([]));
  };

  const naoLidas = notificacoes.filter((n) => n.lido === 0).length;

  // Função para marcar como lida (deletar ou atualizar status)
  const marcarComoLida = (e, id) => {
    e.stopPropagation(); // Evita fechar o modal se clicar sem querer
    const token = localStorage.getItem("Token");

    // Atualização otimista (remove da tela antes da API responder para parecer instantâneo)
    setNotificacoes((prev) => prev.filter((n) => n.id !== id));

    axios
      .delete(`/api/notificacoes/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .catch((err) => {
        console.error("Erro ao limpar notificação", err);
        fetchNotificacoes(); // Reverte se der erro
      });
  };

  // Renderização do conteúdo do modal
  const modalContent = (
    <>
      {open && <div className="notif-overlay" onClick={() => setOpen(false)} />}
      {open && (
        <div className="notif-panel">
          <div className="notif-header">
            <span className="notif-title">Central de Notificações</span>
            <button className="close-btn" onClick={() => setOpen(false)}>
              <X size={18} />
            </button>
          </div>

          <div className="notif-list">
            {notificacoes.length === 0 ? (
              <div className="empty-state">
                <Inbox size={48} strokeWidth={1} style={{ opacity: 0.5 }} />
                <span>Tudo limpo por aqui!</span>
              </div>
            ) : (
              notificacoes.map((n) => (
                <div
                  key={n.id}
                  className={`notif-item ${n.lido === 0 ? "unread" : ""}`}
                  onClick={(e) => marcarComoLida(e, n.id)}
                  title="Clique para marcar como lida"
                >
                  <div className="notif-icon-box">
                    <Info size={18} />
                  </div>

                  <div className="notif-content">
                    <div className="notif-msg">{n.mensagem}</div>
                    <div className="notif-date">
                      <i className="far fa-clock"></i>
                      {new Date(n.criado_em).toLocaleDateString()} às{" "}
                      {new Date(n.criado_em).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </div>

                  {/* Ícone de ação sutil ao passar o mouse */}
                  <div className="text-muted opacity-50">
                    <CheckCircle size={14} />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </>
  );

  // Garante que o portal tenha onde renderizar, mesmo se não houver 'modal-root'
  const portalRoot = document.getElementById("modal-root") || document.body;

  return (
    <div className="notificacoes-container">
      <button className="bell-btn" onClick={() => setOpen(!open)}>
        <Bell size={20} />
        {naoLidas > 0 && (
          <span className="badge-count">{naoLidas > 9 ? "9+" : naoLidas}</span>
        )}
      </button>

      {ReactDOM.createPortal(modalContent, portalRoot)}
    </div>
  );
}

export default Notificacoes;
